import { render, staticRenderFns } from "./PatientCoverage.vue?vue&type=template&id=1028511a"
import script from "./PatientCoverage.vue?vue&type=script&lang=js"
export * from "./PatientCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports